import clsx from "clsx";
import React from "react";
import { ProductImage } from "web/react/emo/product-image";
import {
    DesignerSerializer,
    ProductBuyOptionsSerializer,
    ProductSerializer,
} from "web/types/serializers";
import { ProductCardHorizontalDetails } from "./product-card-horizontal-details";
import * as styles from "./product-card-horizontal.css";

export interface ProductCardHorizontalProps {
    product: ProductSerializer;
    designer: DesignerSerializer;
    buyOption: ProductBuyOptionsSerializer | null;
    className?: string;
    dataTestId?: string;
    imageWidth?: number;
    imageHeight?: number;
    ImageContainer: React.ComponentType<{ children: React.ReactNode }>;
    ViewProductDetailsContainer: React.ComponentType<{ children: React.ReactNode }>;
    children?: React.ReactNode;
}

export const ProductCardHorizontal = ({
    product,
    designer,
    buyOption,
    className,
    dataTestId,
    children,
    ImageContainer,
    ViewProductDetailsContainer,
}: ProductCardHorizontalProps): React.ReactElement => {
    return (
        <div className={clsx(styles.productCard, className)} data-testid={dataTestId}>
            <ImageContainer>
                {product?.images.length > 0 && (
                    <ProductImage
                        src={product?.images[0]?.large_url || ""}
                        alt={product?.short_description || ""}
                        lazy={false}
                    />
                )}
            </ImageContainer>
            <div className={styles.rightColumn}>
                <ProductCardHorizontalDetails
                    product={product}
                    designer={designer}
                    buyOption={buyOption}
                    ViewProductDetailsContainer={ViewProductDetailsContainer}
                />
                {children && <div className={styles.optionalChildrenContainer}>{children}</div>}
            </div>
        </div>
    );
};
